import { useEffect, useState } from 'react';
import { LAST_PAGE_KEY, TOTAL_PAGES } from '@/lib/book';

export function readLastPage(): number {
  try {
    const raw = window.localStorage.getItem(LAST_PAGE_KEY);
    const n = raw ? Number.parseInt(raw, 10) : Number.NaN;
    if (!Number.isNaN(n) && n >= 1 && n <= TOTAL_PAGES) return n;
  } catch {
    /* localStorage unavailable */
  }
  return 1;
}

export function saveLastPage(page: number): void {
  try {
    window.localStorage.setItem(LAST_PAGE_KEY, String(page));
  } catch {
    /* ignore */
  }
}

export function useLastPage(): number {
  const [last, setLast] = useState(1);
  useEffect(() => {
    setLast(readLastPage());
  }, []);
  return last;
}